import React from 'react';
import { BiCheck, BiStore } from 'react-icons/bi';

import * as S from './styles';

interface CompanyTileProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  name: string;
  distance?: number;
  closest: boolean;
  current: boolean;
  selected: boolean;
}

const CompanyTile: React.FC<CompanyTileProps> = ({
  name,
  selected,
  distance,
  closest,
  current,
  ...props
}) => {
  return (
    <S.Container type="button" checked={selected} {...props}>
      <div className="icon-container">
        <BiStore size={22} />
      </div>
      <div className="content">
        <h3>{name}</h3>
        {distance && <h4>{Math.round(distance / 100) / 10} km de distância</h4>}
      </div>
      {closest && (
        <div className="badge">
          <p>Mais próximo</p>
        </div>
      )}
      {current && (
        <div className="here">
          <p>Você está aqui</p>
        </div>
      )}
      <div className={`check ${selected ? 'checked' : 'unchecked'}`}>
        {selected && <BiCheck size={14} />}
      </div>
    </S.Container>
  );
};

export default CompanyTile;
